/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
import ax from "@/utils/axios";
import store from "@/store/index"
import axios from "axios";
import config from "@/config";
import {Message} from "view-design";

const { baseURL,mock } = config;

/**
 * 下载接口
 * 返回接收示例
 *==================
 const a = document.createElement('a');
 document.body.appendChild(a)
 a.style.display = 'none'
 // 使用获取到的blob对象创建的url
 const url = window.URL.createObjectURL(res);
 a.href = url;
 a.click();
 document.body.removeChild(a)
 // 移除blob对象的url
 window.URL.revokeObjectURL(url);
 * =====================================
 * @param url
 * @param params
 * @returns {Promise<any>}
 */

function delparams(data){
  Object.keys(data).forEach(item=>{
    if (data[item]===""||data[item]===null){
      delete data[item]
    }
  })

  return data;
}

function getInstitutionId(){
  return store.getters.getUserInfo.institution && store.getters.getUserInfo.institution.id ? store.getters.getUserInfo.institution.id : "";
}

function checkInstitutionId(data){
  if (store && (!data || (data.institutionId === null || data.institutionId === undefined || data.institutionId === "undefined" || data.institutionId.length === 0))){
    data = {...data, ...{
        institutionId: getInstitutionId()
      }
    }
  }

  delparams(data);
  return data;
}

function checkStreetCode(data){
  if (store && (!data || (data.streetCode === null || data.streetCode === undefined))){
    data = {...data, ...{
        streetCode: store.getters.getUserInfo.code && store.getters.getUserInfo.code.streetCode ?
          store.getters.getUserInfo.code.streetCode : (store.getters.getUserInfo.code ? store.getters.getUserInfo.code.tenantCode : "")
      }}
  }
  delparams(data);
  return data;
}

export function download(url, params, headerconfig, downloadProgress, downloadAfterHandle){
  params = checkInstitutionId(params)
  return new Promise((resolve, reject) =>{
    axios({
      url: baseURL + url,
      method: 'get',
      params: params,
      responseType:'blob',
      headers:{'Authorization': JSON.parse(sessionStorage.getItem("userInfo"))["accessToken"],'Content-Type':headerconfig,'tenantId': getInstitutionId()},
      onDownloadProgress:(progressEvent)=>{
        if (typeof downloadProgress === 'function') {
          downloadProgress(progressEvent)
        }
      }
    }).then(res=>{
      if (res.data.size!==0){
        store.commit("newShow",{show:true})
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: headerconfig?headerconfig:'application/vnd.ms-excel;charset=utf-8'});
        //获取heads中的filename文件名
        let temp = !res.headers["content-disposition"] || res.headers["content-disposition"].length === 0 ? "" : window.decodeURI(res.headers["content-disposition"].split(";")[1].split("filename=")[1]);
        //对文件名乱码转义--【Node.js】使用iconv-lite解决中文乱码
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', temp)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        store.commit("newShow",{show:false})
        store.commit("newpercent",{percent:0})
      }else{
        //Message.error('没有数据可以下载')
        store.commit("newShow",{show:false})
        store.commit("newpercent",{percent:0})
      }

      if (typeof downloadProgress === 'function') {
        downloadAfterHandle();
      }
    })
  });
}

export function get(url, params){
  params = checkInstitutionId(params)
  return new Promise((resolve, reject) =>{
    ax.get(url, {
      params: params,
      headers: {
        'tenantId': getInstitutionId()
      }
    }).then(res => {
      resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

export function getNotInstitutionId(url, params){
  return new Promise((resolve, reject) =>{
    ax.get(url, {
      params: params,
      headers: {
        'tenantId': getInstitutionId()
      }
    }).then(res => {
      resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

/**
 * post方法，对应post请求
 * @param url {String}  [请求的url地址]
 * @param params {Object} [请求时携带的参数]
 */
export function post(url, params) {
  params = checkInstitutionId(params)
  return new Promise((resolve, reject) => {
    ax.post(url,JSON.stringify(params),{
      headers: {
        'Content-Type': 'application/json',
        'tenantId': getInstitutionId()
      }
    }).then(res => {
        resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

export function postNotInstitutionId(url, params) {
  return new Promise((resolve, reject) => {
    ax.post(url,JSON.stringify(params),{
      headers: {
        'Content-Type': 'application/json',
        'tenantId': getInstitutionId()
      }
    }).then(res => {
        resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

export function postfrom(url, params) {
  if (mock){ //开启mock时屏蔽表单提交
    return post(url,params);
  }
  let formData = new FormData();
  if (params.files){
    for (const file of params.files) {
      formData.append('files', file);
    }
    delete params.files
  }
  params = checkInstitutionId(params)
  for(let key in params){
    formData.append(key,params[key])
  }

  return new Promise((resolve, reject) => {
    ax.post(url, formData, {
      headers: {
        'tenantId': getInstitutionId()
      }
    }).then(res => {
      resolve(res);
    }).catch(err =>{
      reject(err)
    })
  });
}

export function getByStreetCode(url, params){
  params = checkStreetCode(params)
  return new Promise((resolve, reject) =>{
    ax.get(url, {
      params: params,
      headers: {
        'tenantId': getInstitutionId()
      }
    }).then(res => {
      resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

export function postByStreetCode(url, params) {
  params = checkStreetCode(params)
  //console.log(params,'params1')
  return new Promise((resolve, reject) => {
    ax.post(url, JSON.stringify(params),{
      headers: {
        'Content-Type': 'application/json',
        'tenantId': getInstitutionId()
      }
    }).then(res => {
        resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

/**
 * postfrom，对应post序列化请求请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postfromByStreetCode(url, params) {
  let formData = new FormData();
  if (params.files){
    for (const file of params.files) {
      formData.append('files', file);
    }
    delete params.files
  }
  params = checkStreetCode(params)
  for(let key in params){
    formData.append(key,params[key])
  }

  return new Promise((resolve, reject) => {
    ax.post(url, formData, {
      headers: {
        'tenantId': getInstitutionId()
      }
    }).then(res => {
        resolve(res);
    }).catch(err =>{
      reject(err.data)
    })
  });
}

